export default __webpack_public_path__ + "static/media/app-screens-v3-67-1_02.2160e4fd.jpg";